import { asyncAction, action } from 'lib/actions';

export const fetchSurfacesAction = asyncAction('surfaces/FETCH');
export const setCommonSurfacesAction = action('surfaces/SET_COMMON');
